export const CREATE_ITEM_LOT_RATE = 'CREATE_ITEM_LOT_RATE';
export const UPDATE_ITEM_LOT_RATE = 'UPDATE_ITEM_LOT_RATE';
export const DELETE_ITEM_LOT_RATE = 'DELETE_ITEM_LOT_RATE';
export const GET_ITEM_LOT_RATE = 'GET_ITEM_LOT_RATE';
export const ITEM_LOT_RATE_REQUEST = 'ITEM_LOT_RATE_REQUEST';
export const ITEM_LOT_RATE_REQUEST_SUCCESS  = 'ITEM_LOT_RATE_REQUEST_SUCCESS';
export const ITEM_LOT_RATE_REQUEST_FAILURE = 'ITEM_LOT_RATE_REQUEST_FAILURE';
export const GET_ITEM_LOT_RATE_PAGE  = 'GET_ITEM_LOT_RATE_PAGE';